import { atom, useSetAtom } from 'jotai';
export const modalAtom = atom({
    isOpen: false,
    config: undefined
});
export const toastAlertAtom = atom({
    show: false,
    toastMessageText: '',
    toastMessageType: 'info'
});
export const showToastAtom = atom(null, (get, set, { message, type }) => {
    set(toastAlertAtom, {
        show: true,
        toastMessageText: message,
        toastMessageType: type
    });
});
export const detailSidebarAtom = atom({
    isOpen: false,
    entity: null,
    entityType: 'product'
});
export function useModalActions() {
    const setModal = useSetAtom(modalAtom);
    const openModal = (config) => setModal({ isOpen: true, config: config });
    return { openModal };
}
